import { AllocationReportsProps } from './AllocationReports.types';
import AllocationReportModal from '../AllocationReportModal/AllocationReportModal';

export const AllocationReports: React.FC<AllocationReportsProps> = ({
  handleAllocationModalClose,
  isAllocationReportOpen,
  reportType,
  initialReportType,
}) => {
  if (!isAllocationReportOpen) {
    return null;
  }

  return (
    <AllocationReportModal
      onClose={handleAllocationModalClose}
      defaultReportType={reportType}
      initialReportType={initialReportType}
    />
  );
};
